// extracted by mini-css-extract-plugin
export default {"container":"documentSectionListPanel_container__RzV8u"};